export default enabledFlippers => ({
  flippers: (enabledFlippers || []).reduce((acc, flipperName) => ({
    ...acc,
    [flipperName]: {
      enabled: true,
      throttle: 100
    }
  }), {})
});